import _ from "lodash";
import React, { useState } from "react";
import { updateLabourBreakup, reCalculateLabourBreakup } from "api";
import { EditInputs } from "components/Pricing/EditInputs";
import Loading from "components/Event/Loading";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { pricingQualityList } from "content/static";
import { faTrash } from "@fortawesome/free-solid-svg-icons";

const LabourBreakupModal = ({
  key,
  showLabourModal,
  labourLoader,
  currentLabourDetails,
  deletestoneDetails,
  handleReCalculateLabour,
  details,
  handleLabourDelete,
  lhsAmtTotal,
  setLhsAmtTotal,
  setRhsAmtTotal,
  rhsAmtTotal,
  labourDetailError,
}) => {
  // console.log("🚀 ~ deletestoneDetails:", deletestoneDetails.priceDetail);
  
  const [updatedLabourData, setUpdatedLabourData] = useState([]);

  const DetailTable = ({
    headingclassName,
    title,
    filterBy,
    setRhsAmtTotal,
    // setLhsAmtTotal,
    total,
    details,
  }) => {
    const labourLotCode = currentLabourDetails.filter(
      (detail) => detail.custOrFact === filterBy
    );

    const updatedLotCode = _.groupBy(labourLotCode, ({ lotCode }) => lotCode);
    const handleChangeLabour = async (e, data, rowId, item, key) => {
      e.preventDefault();
      const inputValue = Number(e.target.value);
    
      try {
        let rate, quantity;
        if (key === "rate") {
          rate = inputValue;
          quantity = item.quantity;
        } else {
         
          rate = item.rate;
          quantity = inputValue;
        }
    
        const ResponseData = await updateLabourBreakup({
          priceDetailsId: data._id,
          labourBreakupId: rowId,
          rate,
          quantity,
        });
    
        const rhsAmtTotal = ResponseData?.data?.data?.rhsAmtTotal;
        if (rhsAmtTotal !== undefined) {
          item.rate = Number(rate);
          item.quantity = Number(quantity);
          item.amount = ResponseData.data.data.labourAmount;
          setRhsAmtTotal(rhsAmtTotal);
          details.rhsAmtTotal = rhsAmtTotal;
        } else {
          item.rate = rate === "" ? "" : 0;
          item.quantity = quantity === "" ? "" : 0;
          item.amount = 0; 
        }
  
      } catch (error) {
        console.error("Error:", error);
      }
    };
    



    return (
      <div className="col-6">
        <h4 className={headingclassName}>{title}</h4>
        <table className="smartTable-table table table-striped border">
          <thead className="smartTable-head">
            <tr className="labour_table_head">
              <th>Charge Type</th>
              <th>Quantity</th>
              <th className="text-right">Rate</th>
              <th className="text-right">Amount</th>
            </tr>
          </thead>
          <tbody>
            {Object.keys(updatedLotCode).map((labourDetail, innerIndex) => {
              const labourTableData = updatedLotCode[labourDetail];

              return (
                <React.Fragment key={innerIndex}>
                  <tr style={{ backgroundColor: "#EFF9FF", fontWeight: "700" }}>
                    <td style={{ background: "#eff9ff00" }}>
                      {labourDetail === "Stone"
                        ? "Setting Type (Stone)"
                        : "Process Name (Metal)"}
                    </td>
                    <td style={{ background: "#eff9ff00" }}></td>
                    <td style={{ background: "#eff9ff00" }}></td>
                    <td style={{ background: "#eff9ff00" }}></td>
                  </tr>
                  {labourTableData.map((item, innerIndex) => {
                    return (
                      <tr key={innerIndex}>
                        <td>
                          {item.chargeType}
                          <ActionBtn
                            deleteAction={() =>
                              handleLabourDelete(
                                details,
                                item,
                                deletestoneDetails
                              )
                            }
                          />
                        </td>
                       
                        <td className="text-right">
                          {title === "RHS Details" ? (
                            <EditInputs
                              // pointer = {{cursor:"pointer"}}
                              className={
                                "form-control form-control-sm w-50 text-left ml-auto "
                              }
                              disabled={false}
                              defaultValue={item.quantity}
                              onBlur={(e) => {
                                const inputValue = e.target.value;

                                if (inputValue) {
                                  handleChangeLabour(
                                    e,
                                    details,
                                    item._id,
                                    item,
                                    "quantity"
                                  );
                                }
                              }}
                            />
                          ) : (
                            <>{item.quantity}</>
                          )}
                        </td>

                        <td className="text-right">
                          {title === "RHS Details" ? (
                            <EditInputs
                              // pointer = {{cursor:"pointer"}}
                              className={
                                "form-control form-control-sm w-50 text-left ml-auto "
                              }
                              disabled={false}
                              defaultValue={item.rate}
                              onBlur={(e) => {
                                const inputValue = e.target.value;

                                if (inputValue) {
                                  handleChangeLabour(
                                    e,
                                    details,
                                    item._id,
                                    item,
                                    "rate"
                                  );
                                }
                              }}
                            />
                          ) : (
                            <>{item.rate}</>
                          )}
                        </td>

                        <td className="text-right">{item.amount}</td>
                      </tr>
                    );
                  })}
                </React.Fragment>
              );
            })}
          </tbody>
          <tfoot>
            <tr>
              <td></td>
              <td></td>

              <td className="text-right">
                <h5 className={"fw-bold " + headingclassName}>Total</h5>
              </td>
              <td className="text-right">
                <h5 className={"fw-bold " + headingclassName}>
                  {typeof total !== "undefined" ? total.toFixed(3) : ""}
                </h5>
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    );
  };

  return (
    <div
      key={key}
      className={`modal fade ${showLabourModal ? "show" : ""}`}
      id="exampleModal1"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-full-width">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="exampleModalLabel">
              Labour Breakup Details
            </h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            {labourLoader ? (
              <div
                className="d-flex justify-content-center align-items-center"
                style={{ height: "50vh" }}
              >
                <Loading />
              </div>
            ) : labourDetailError.message === "success" ? (
              <div className="row" style={{ overflowY: "auto" }}>
                {updatedLabourData.status === 404 ? (
                  <></> // Placeholder for empty state
                ) : (
                  <DetailTable
                    headingclassName={"lhsText"}
                    title={"LHS Details"}
                    filterBy={"factory"}
                    total={lhsAmtTotal}
                    details={details}
                    setLhsAmtTotal={setLhsAmtTotal}
                  />
                )}

                {updatedLabourData.status === 404 ? (
                  <>{updatedLabourData.message}</> // Placeholder for message
                ) : (
                  <DetailTable
                    headingclassName={"rhsText"}
                    title={"RHS Details"}
                    filterBy={"customer"}
                    total={rhsAmtTotal}
                    details={details}
                    setRhsAmtTotal={setRhsAmtTotal}
                  />
                )}
              </div>
            ) : (
              labourDetailError.message && <>{labourDetailError.message}</>
            )}
          </div>

          <div className="modal-footer">
            {/* <button
              type="button"
              className="btn btn-info"
              onClick={() => {
                handleReCalculateLabour(
                  details._id,
                  deletestoneDetails,
                  "singleLabour"
                );
              }}
            >
              {" "}
              Re-Calculate
            </button> */}

            <button
              type="button"
              className="btn btn-secondary"
              data-dismiss="modal"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

const ActionBtn = ({ deleteAction }) => {
  return (
    <FontAwesomeIcon
      type="button"
      data-toggle="modal"
      title="delete metalLoss"
      data-target="#exampleModal"
      className="px-1 delete_chainStone"
      icon={faTrash}
      size="xs"
      color="black"
      onClick={deleteAction}
    />
  );
};

export default LabourBreakupModal;
